<div class="container-fluid">
  <div class="row mx-2">
    <h1 class="col-12 fw-700 mt-3">Terms and Conditions</h1>
    <h5 class="col-12 fw-700 my-2 mt-3"><u> END USER LICENSE AGREEMENT </u></h5>
    <p class="col-12 my-2 text-justify">
      The following End User License Agreement (the “EULA”) governs the use of Jikia (“we,” “our,” or “us”) websites,
      located at <a href="http://citizex.ai" target="_blank">citizex.ai</a>, and participation in any online
      features, services, and/or programs offered by us
      (collectively, the “Website”). This EULA is in effect for all of our Websites.
    </p>
    <p class="col-12 my-2 text-justify fw-700">
      BY ACCESSING OR USING OUR WEBSITES, YOU ARE ENTERING INTO A LEGAL CONTRACT WITH JIKIA REGARDING YOUR USE OF THE
      WEBSITES AND YOU AGREE TO BE BOUND BY THIS EULA. IF YOU DO NOT AGREE TO ANY PORTION OF THIS EULA, YOU SHOULD NOT
      ACCESS OR OTHERWISE USE THE WEBSITE.
    </p>
    <p class="col-12 my-2 text-justify">
      You should carefully review this entire EULA. Included in this legal contract are:
    </p>
    <p class="col-12 my-2 text-justify">
      (i) requirements that you provide truthful, accurate, current, and complete information about your identity;
    </p>
    <p class="col-12 my-2 text-justify">
      (ii) prohibitions on allowing anyone or any entity other than yourself to use your user account; and

    </p>
    <p class="col-12 my-2 text-justify">
      (iii) terms indicating that you are responsible for any legal issues caused by your content or your use of the
      Websites.
    </p>
  </div>
  <hr>
  <div class="row mx-2">
    <h5 class="col-12 fw-700 mt-3"><u>TABLE OF CONTENTS</u></h5>
    <div class="col-auto"></div>
    <div class="col my-2">
      <ol>
        <li class="my-2">Convenience and Information Only</li>
        <li class="my-2">User Account</li>
        <li class="my-2">Accurate and Truthful Information</li>
        <li class="my-2">Account Deactivation</li>
        <li class="my-2">Objectionable Material</li>
        <li class="my-2">Content</li>
        <li class="my-2">Our Participation</li>
        <li class="my-2">No Warranties; Limitation of Liability; Indemnification</li>
        <li class="my-2">Jurisdiction and Venue</li>
        <li class="my-2">Miscellaneous</li>
        <li class="my-2">Phone Number</li>
      </ol>
    </div>
  </div>
  <hr>
  <div class="row mx-2 terms-list-style">
    <ol class="col mx-2">
      <li class="my-2">
        <span class="fw-700">CONVENIENCE AND INFORMATION ONLY.</span>
        <p class="mt-2 mb-2">The Websites are provided to you as a convenience and for informational purposes only. By
          merely providing
          access to the Website, we do <b>not</b> guarantee, warrant, or represent that:
        </p>
      </li>
      <div class="col my-2">
        <ul style="list-style-type:disc">
          <li class="my-2">
            Any materials, statements, reviews, ratings, opinions, documents, images, graphics, logos, designs, audio,
            video, comments, or other information (collectively, the “Content”) are accurate or complete;
          </li>
          <li class="my-2">The Content is up-to-date or current;</li>
          <li class="my-2">We have any obligation to update any Content;</li>
          <li class="my-2">
            We will keep your Content confidential or restrict third parties from using your Content;
          </li>
          <li class="my-2">
            Any use of the Content is free from claims such as intellectual property infringement, defamation, or
            violations of publicity rights;
          </li>
          <li class="my-2">
            The Content is free from third-party alterations;
          </li>
          <li class="my-2">
            Your access to the Website will be uninterrupted, error-free, or free of viruses or harmful components;
          </li>
          <li class="my-2">No data breach will ever occur; and/or</li>
          <li class="my-2">
            Information transmitted over the Internet is secure or free from delay, interruption, interception, or
            error.
          </li>
        </ul>
      </div>
      <hr>
      <li class="my-2">
        <span class="fw-700">USER ACCOUNT.</span>
        <p class="mt-2 text-justify">To access the Website, you must create a user account (“User Account”) with a
          username and
          password. User Accounts are unique to an individual person. You may not create or use a User Account on behalf
          of any organization, entity, or group.</p>
      </li>

      <div class="col my-2">
        <ul style="list-style-type: disc !important;">
          <li class="my-2">You are responsible for maintaining the confidentiality of your login credentials;</li>
          <li class="my-2">You must not share your account with others;</li>
          <li class="my-2">You must notify us immediately of any unauthorized use or breach;</li>
          <li class="my-2">Usernames and passwords are non-transferable;</li>
          <li class="my-2">You must log out after each session.</li>
        </ul>
      </div>
      <hr>
      <li class="my-2">
        <span class="fw-700">ACCURATE AND TRUTHFUL INFORMATION.</span>
        <p class="mt-2">You agree to:</p>
      </li>
      <div class="col my-2">
        <ul style="list-style-type: disc !important;">
          <li class="my-2">Provide true, accurate, current, and complete information (“User Identity”);</li>
          <li class="my-2">Maintain and promptly update your information.</li>
        </ul>
        <p class="mt-2">We may collect and use data, including demographic, political, and technical information,
          provided it does not personally identify you.</p>
      </div>
      <hr>
      <li class="my-2">
        <span class="fw-700">ACCOUNT DEACTIVATION.</span>
        <p class="mt-2">We reserve the right to suspend or terminate your account at our discretion, including if:</p>
      </li>
      <div class="col my-2">
        <ul style="list-style-type: disc !important;">
          <li class="my-2">You provide inaccurate information;</li>
          <li class="my-2">You request deactivation;</li>
          <li class="my-2">You are deceased;</li>
          <li class="my-2">You fail to respond to communications;</li>
          <li class="my-2">You use the account improperly or fraudulently;</li>
          <li class="my-2">You allow unauthorized access to your account.</li>
        </ul>
      </div>
      <hr>
      <li class="my-2">
        <span class="fw-700">OBJECTIONABLE MATERIAL.</span>
        <p class="mt-2 text-justify">You acknowledge that you may encounter content that is offensive or inappropriate.
          You agree to use the Website at your own risk, and we are not liable for such content.</p>
      </li>
      <hr>
      <li class="my-2">
        <span class="fw-700">CONTENT</span>
      </li>
      <div class="col my-2">
        <ul style="list-style-type: disc !important;">
          <li class="my-2">You must not upload content containing personally identifiable information of others;</li>
          <li class="my-2">Uploading images or videos of others without consent is prohibited;</li>
          <li class="my-2">You are solely responsible for your content;</li>
          <li class="my-2">You must have all necessary rights and permissions;</li>
          <li class="my-2">You grant us a worldwide, non-exclusive, royalty-free license to use your content;</li>
          <li class="my-2">We may remove content at our discretion.</li>
        </ul>
        <p class="mt-2 text-justify">You agree not to post content that is unlawful, abusive, harmful, or otherwise
          inappropriate, including content that harms minors.</p>
      </div>
      <hr>
      <li class="my-2">
        <span class="fw-700">OUR PARTICIPATION.</span>
        <p class="mt-2 text-justify">We do not endorse user content and disclaim all liability related to it. We reserve
          the right to remove content and terminate accounts of repeat offenders.</p>
      </li>
      <hr>
      <li class="my-2">
        <span class="fw-700">NO WARRANTIES; LIMITATION OF LIABILITY; INDEMNIFICATION</span>
      </li>
      <div class="col my-2">
        <p><b>No Warranties</b></p>
        <p>The Website is provided “as is” without warranties of any kind.</p>
        <p class="mt-3"><b>Limitation of Liability</b></p>
        <p>We are not liable for damages arising from use of the Website. Our total liability is limited to amounts paid
          by you in the past six months, if any.</p>
        <p class="mt-3"><b>Indemnification</b></p>
        <p>You agree to indemnify and hold us harmless from any claims arising from your use of the Website or your
          content.</p>
      </div>
      <hr>
      <li class="my-2">
        <span class="fw-700">JURISDICTION AND VENUE.</span>
        <p class="mt-2 text-justify">This Agreement is governed by the laws of the State of California. Any disputes
          shall be resolved in courts located in the Central District of California, unless otherwise required by
          applicable law.</p>
      </li>
      <hr>
      <li class="my-2">
        <span class="fw-700">MISCELLANEOUS</span>
      </li>
      <div class="col my-2">
        <ul style="list-style-type: disc !important;">
          <li class="my-2">If any part of this EULA is invalid, the rest remains in effect;</li>
          <li class="my-2">This is the entire agreement between you and Jikia;</li>
          <li class="my-2">Changes must be agreed to in writing.</li>
        </ul>
      </div>
      <hr>
      <li class="my-2">
        <span class="fw-700">PHONE NUMBER</span>
      </li>
      <div class="col my-2">
        <ul style="list-style-type: disc !important;">
          <li class="mt-2 text-justify">CitizeX only sends transactional OTPs.</li>
          <li class="mt-2 text-justify">If a user opts into sharing data with a Host, any subsequent SMS communication
            from that Host is a separate relationship between the user and the Host.</li>
        </ul>
      </div>
    </ol>
  </div>
</div>